import { resolveCloudVideoUrl } from "../../lib/utils";

const cloudVideo = (relativePath) => resolveCloudVideoUrl(`instructions/videos/${relativePath}`);

const VIDEO_VARIANTS_FR = [
  cloudVideo("basicControls/speed_slow_FR.mp4"),
  cloudVideo("basicControls/speed_up_FR.mp4"),
  cloudVideo("m0/0_solve_FR.mp4"),
  cloudVideo("m1/1_solve_FR.mp4"),
  cloudVideo("m2/2_pass-truck_FR.mp4"),
  cloudVideo("m2/2_truck-interact_FR.mp4"),
  cloudVideo("m5/mission_5-05_FR.mp4"),
  cloudVideo("m5/mission_5-07_FR.mp4"),
  cloudVideo("m5/mission_5-09_FR.mp4"),
];

const VIDEO_VARIANTS_DE = [
  cloudVideo("basicControls/speed_slow_DE.mp4"),
  cloudVideo("basicControls/speed_up_DE.mp4"),
  cloudVideo("m0/0_solve_DE.mp4"),
  cloudVideo("m1/1_solve_DE.mp4"),
  cloudVideo("m2/2_pass-truck_DE.mp4"),
  cloudVideo("m2/2_truck-interact_DE.mp4"),
  cloudVideo("m5/mission_5-05_DE.mp4"),
  cloudVideo("m5/mission_5-07_DE.mp4"),
  cloudVideo("m5/mission_5-09_DE.mp4"),
];

const preloadLayouts = [
  {
    id: "QWERTY_USUK",
    assets: [],
    videos: [],
  },
  {
    id: "AZERTY_FR",
    assets: [],
    videos: VIDEO_VARIANTS_FR,
  },
  {
    id: "QWERTZ_DECH",
    assets: [],
    videos: VIDEO_VARIANTS_DE,
  },
];

/**
 * Layout IDs that share assets with another layout.
 * Matches the fallback behaviour defined in keyboardLayoutConfig.ts.
 */
const LAYOUT_ASSET_FALLBACKS = {
  ABNT2_BR: "QWERTY_USUK",
};

/**
 * Returns layout-specific assets for a given keyboard layout ID.
 * @param {string} layoutId - e.g. "QWERTY_USUK", "AZERTY_FR", "QWERTZ_DECH", "ABNT2_BR"
 * @returns {string[]}
 */
export function getLayoutAssets(layoutId) {
  const resolvedId = LAYOUT_ASSET_FALLBACKS[layoutId] ?? layoutId;
  const layout = preloadLayouts.find((l) => l.id === resolvedId);
  if (!layout) {
    console.warn(`[preloadLayouts] No layout found for id: "${layoutId}" (resolved: "${resolvedId}")`);
    return [];
  }
  return layout.assets;
}

/**
 * Returns layout-specific video assets for a given keyboard layout ID.
 * @param {string} layoutId - e.g. "QWERTY_USUK", "AZERTY_FR", "QWERTZ_DECH", "ABNT2_BR"
 * @returns {string[]}
 */
export function getLayoutVideoAssets(layoutId) {
  const resolvedId = LAYOUT_ASSET_FALLBACKS[layoutId] ?? layoutId;
  const layout = preloadLayouts.find((l) => l.id === resolvedId);
  if (!layout) {
    console.warn(`[preloadLayouts] No layout found for id: "${layoutId}" (resolved: "${resolvedId}")`);
    return [];
  }
  return layout.videos ?? [];
}

export default preloadLayouts;